import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row justify-content-center mt-3 mt-md-5 mb-5" }
const _hoisted_2 = { class: "col-12 col-lg-8" }
const _hoisted_3 = {
  key: 0,
  class: "my-5 text-center"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-3x fa-spin fa-spinner" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  class: "bf-modal__section bf-bg-primary",
  style: {"padding":"30px"}
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-between" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bf-heading-script mb-3" }, "Kurstermin")
], -1)
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-12 col-lg-6" }
const _hoisted_11 = { class: "bf-modal-appointment-detail__name" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString('' /* @TODO: centralize */) + " ")
const _hoisted_13 = { class: "me-1" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-info-circle",
  "aria-label": 'Kursbeschreibung'
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "Kursbeschreibung", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "bf-modal-appointment-detail__horizontal-divider mx-2" }, "–", -1)
const _hoisted_19 = { class: "bf-modal-appointment-detail__mode text-nowrap" }
const _hoisted_20 = { class: "bf-modal-appointment-detail__start" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("b", null, "Einzeltermin:", -1)
const _hoisted_22 = { class: "bf-modal-appointment-detail__start-date" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-calendar-check" }, null, -1)
const _hoisted_24 = { class: "bf-modal-appointment-detail__start-time" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-fw fa-clock" }, null, -1)
const _hoisted_26 = {
  key: 0,
  class: "bf-modal-appointment-detail__enrollment_deadline"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("b", null, "Anmeldefrist:", -1)
const _hoisted_28 = {
  key: 1,
  class: "bf-modal-appointment-detail__withdrawal_deadline"
}
const _hoisted_29 = /*#__PURE__*/_createElementVNode("b", null, "Abmeldefrist:", -1)
const _hoisted_30 = {
  key: 0,
  class: "col-12 col-lg-6"
}
const _hoisted_31 = {
  key: 0,
  class: "bf-modal-course-detail__location"
}
const _hoisted_32 = /*#__PURE__*/_createElementVNode("b", null, "Trainingsort:", -1)
const _hoisted_33 = { class: "bf-modal-course-detail__gathering" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("b", null, "Treffpunkt:", -1)
const _hoisted_35 = {
  key: 1,
  class: "bf-modal-course-detail__bringalong"
}
const _hoisted_36 = {
  key: 0,
  class: "bf-modal-appointment-detail__info_text"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("b", null, "Kursinformationstext:", -1)
const _hoisted_38 = { class: "bf-modal__section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Popper = _resolveComponent("Popper")!
  const _component_AppointmentEnrollmentStatus = _resolveComponent("AppointmentEnrollmentStatus")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            (_ctx.appointmentLocal)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_7, [
                    _hoisted_8,
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createVNode(_component_Popper, {
                            hover: true,
                            arrow: true
                          }, {
                            content: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _hoisted_15,
                                _hoisted_16,
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.descriptionLines, (line) => {
                                  return (_openBlock(), _createElementBlock(_Fragment, { key: line }, [
                                    _createElementVNode("span", null, _toDisplayString(line), 1),
                                    _hoisted_17
                                  ], 64))
                                }), 128))
                              ])
                            ]),
                            default: _withCtx(() => [
                              _createElementVNode("span", null, [
                                _createElementVNode("b", _hoisted_13, _toDisplayString(_ctx.appointmentLocal.course.course_type.name), 1),
                                _hoisted_14
                              ])
                            ]),
                            _: 1
                          }),
                          _hoisted_18,
                          _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.appointmentLocal.course.mode === 0 ? 'Offener Kurs' : 'Geschlossener Kurs'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            _hoisted_23,
                            _createTextVNode(" " + _toDisplayString(_ctx.formatDateWithDayLabel(_ctx.appointmentLocal.start)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_24, [
                            _hoisted_25,
                            _createTextVNode(" " + _toDisplayString(_ctx.formatTime(_ctx.appointmentLocal.start)) + " – " + _toDisplayString(_ctx.formatTime(_ctx.appointmentLocal.end)) + " Uhr ", 1)
                          ])
                        ]),
                        (_ctx.appointmentLocal.enrollment_deadline)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                              _hoisted_27,
                              _createTextVNode(" " + _toDisplayString(_ctx.formatDatetimeWithDayLabel(_ctx.appointmentLocal.enrollment_deadline)), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.appointmentLocal.withdrawal_deadline)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              _hoisted_29,
                              _createTextVNode(" " + _toDisplayString(_ctx.formatDatetimeWithDayLabel(_ctx.appointmentLocal.withdrawal_deadline)), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (_ctx.appointmentLocal.course)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                            (_ctx.appointmentLocal.course.location?.name)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _hoisted_32,
                                  _createTextVNode(" " + _toDisplayString(_ctx.appointmentLocal.course.location?.name), 1)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_33, [
                              _hoisted_34,
                              _createTextVNode(" " + _toDisplayString(_ctx.appointmentLocal.course.gathering_name), 1)
                            ]),
                            (_ctx.appointmentLocal.course.info_bringalong)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, _toDisplayString(_ctx.appointmentLocal.course.info_bringalong), 1))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    (_ctx.appointmentLocal.course.info_text)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _hoisted_37,
                          _createTextVNode(" " + _toDisplayString(_ctx.appointmentLocal.course.info_text), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_38, [
                    _createVNode(_component_AppointmentEnrollmentStatus, {
                      "appointment-id": _ctx.appointmentLocal.id,
                      "region-id": _ctx.appointmentLocal.course.region_id,
                      onEnrollmentStatusChange: _ctx.onEnrollmentStatusChange
                    }, null, 8, ["appointment-id", "region-id", "onEnrollmentStatusChange"])
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}